module.exports = __webpack_public_path__ + "f585fe2054b88eb6d1e59cdeda7bb5da.svg";


//////////////////
// WEBPACK FOOTER
// ./src/eraser-color.svg
// module id = 8
// module chunks = 0